<template>
    <td>
        <button
            v-if="editOperations.remove"
            class="k-button k-grid-remove-command"
            @click="removeHandler">
            Remove
        </button>
    </td>
</template>

<script>
export default {
    name: 'inline-commands',
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        idField: String,
        editOperations: Object,
    },
    methods: {
        removeHandler: function() {
            this.$emit('remove', {dataItem:this.dataItem});
        }
    }
};
</script>